import type React from 'react';
import { colors } from '@this/shared/ui/theme/tokens/primitive-tokens/colors';

export function getBaseStyles() {
  return {
    // セクション関連
    section: (() => {
      const sectionBase = {
        backgroundColor: colors.gray[20],
        borderRadius: '8px'
      } as React.CSSProperties;

      return {
        base: {
          ...sectionBase,
          padding: '16px',
          marginBottom: '16px'
        } as React.CSSProperties
      };
    })(),

    // 見出し関連
    heading: {
      title: {
        marginBottom: '16px',
        fontSize: '16px',
        fontWeight: 'bold'
      } as React.CSSProperties,
      base: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: 'bold'
      } as React.CSSProperties,
      sub: {
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: 'bold'
      } as React.CSSProperties
    },

    // グリッドレイアウト
    grid: (() => {
      const gridBase = {
        display: 'grid',
        gridTemplateColumns: '1fr'
      } as React.CSSProperties;

      return {
        single: {
          ...gridBase,
          gap: '14px'
        } as React.CSSProperties
      };
    })(),

    // フィールド関連
    field: {
      base: {
        // marginBottom: '12px'
      } as React.CSSProperties
    },

    // ラベル関連
    label: {
      base: {
        fontSize: '12px',
        color: colors.gray[600],
        marginBottom: '4px',
        display: 'block'
      } as React.CSSProperties
    },

    // ヘルパーテキスト関連
    helperText: {
      base: {
        fontSize: '10px',
        color: colors.gray[600]
      } as React.CSSProperties
    },

    // 値表示関連
    value: (() => {
      const valueBase = {
        color: colors.gray[900],
        wordBreak: 'break-word' as const
      } as React.CSSProperties;

      return {
        base: {
          ...valueBase,
          fontSize: '14px'
        } as React.CSSProperties,
        large: {
          ...valueBase,
          fontSize: '16px'
        } as React.CSSProperties
      };
    })(),

    // ステータス表示
    status: {
      badge: {
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 'bold'
      } as React.CSSProperties
    },

    // 区切り線
    divider: {
      horizontal: {
        borderTop: `1px solid ${colors.gray[200]}`,
        margin: '16px 0'
      } as React.CSSProperties,
      vertical: {
        borderLeft: `3px solid ${colors.gray[100]}`,
        paddingLeft: '16px',
        marginBottom: '16px'
      } as React.CSSProperties
    },

    // モーダル関連
    modal: {
      body: {
        textAlign: 'center' as const,
        padding: '40px 20px'
      } as React.CSSProperties,
      content: {
        textAlign: 'center' as const,
        padding: '40px 20px'
      } as React.CSSProperties,
      title: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '8px'
      } as React.CSSProperties,
      error: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '8px',
        color: colors.red[600]
      } as React.CSSProperties,
      message: {
        fontSize: '16px',
        color: colors.gray[600]
      } as React.CSSProperties
    }
  };
}

export const baseStyles = getBaseStyles();
